/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
let t=0;const n=0;function e(){return++t}export{e as generateUID,n as nullUid};
